/* TALVORE v2 — vitrina, compra rápida y efectos interactivos */
(function () {
  if (window.mtV2) return;
  window.mtV2 = true;
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raizCarrito = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Añadir al carrito sin salir de la página ---------- */
  function toast(img, texto) {
    var t = document.querySelector('.mt-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'mt-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = (img ? '<img src="' + img + '" alt="">' : '') + '<span>' + texto + '</span><a href="' + raizCarrito + 'cart">Ver carrito</a>';
    requestAnimationFrame(function () { t.classList.add('mt-on'); });
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('mt-on'); }, 4200);
  }
  function anadir(id, boton, img) {
    if (!id) return;
    var drawer = document.querySelector('cart-drawer');
    var cuerpo = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer) { cuerpo.sections = 'cart-drawer,cart-icon-bubble'; cuerpo.sections_url = window.location.pathname; }
    if (boton) boton.classList.add('mt-cargando');
    fetch(raizCarrito + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (boton) boton.classList.remove('mt-cargando');
        if (!res.ok) { toast(null, res.j.description || 'No se ha podido añadir'); return; }
        if (boton) { boton.classList.add('mt-ok'); setTimeout(function () { boton.classList.remove('mt-ok'); }, 2200); }
        if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.j);
        } else {
          toast(img, 'Añadido al carrito');
          fetch(raizCarrito + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
            var b = document.getElementById('cart-icon-bubble');
            if (b && s['cart-icon-bubble']) b.innerHTML = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
          }).catch(function () {});
        }
      })
      .catch(function () { if (boton) boton.classList.remove('mt-cargando'); window.location.href = raizCarrito + 'cart'; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mt-comprar]');
    if (!b) return;
    e.preventDefault();
    var tarjeta = b.closest('[data-mt-tarjeta], [data-mt-vitrina]');
    var img = tarjeta && tarjeta.querySelector('[data-mt-img]');
    anadir(b.getAttribute('data-id'), b, img ? img.currentSrc || img.src : null);
  });

  function crearDial(v, i, activo, tam) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mt-dial mt-dial--' + (tam || 'med') + (/total/i.test(v.nombre) ? ' mt-dial--caja-negra' : '') + (activo ? ' mt-activo' : '') + (v.disp === false ? ' mt-agotada' : '');
    b.style.setProperty('--c', v.color);
    b.dataset.i = i; b.dataset.nombre = v.nombre;
    b.setAttribute('aria-label', v.nombre); b.setAttribute('aria-pressed', activo ? 'true' : 'false');
    b.innerHTML = '<span class="mt-dial__bisel" aria-hidden="true"></span><span class="mt-dial__cara" aria-hidden="true">' + (v.esfera ? '<img src="' + v.esfera + '" alt="" width="160" height="160" onerror="this.remove()">' : '') + '</span><span class="mt-dial__brillo" aria-hidden="true"></span>';
    return b;
  }
  function marcar(cont, i) {
    if (!cont) return;
    cont.querySelectorAll('.mt-dial').forEach(function (b, k) {
      var on = k === i;
      if (on && !b.classList.contains('mt-activo')) { b.classList.remove('mt-pulso'); b.offsetWidth; b.classList.add('mt-pulso'); }
      b.classList.toggle('mt-activo', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  /* coloca las esferas en arco alrededor del reloj */
  function colocarOrbita(orb, esc) {
    if (!orb || !esc) return;
    var dials = orb.querySelectorAll('.mt-dial'), n = dials.length;
    var radio = esc.offsetWidth * 0.53, abanico = Math.min(100, 26 * (n - 1));
    dials.forEach(function (d, k) {
      var a = n > 1 ? -abanico / 2 + abanico * k / (n - 1) : 0;
      d.style.setProperty('--a', a + 'deg');
      d.style.setProperty('--r', radio + 'px');
      d.style.setProperty('--d', (k * 90) + 'ms');
    });
  }

  function datos(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* ---------- Vitrina de la portada ---------- */
  function initVitrina(sec) {
    if (sec.dataset.mtListo) return;
    sec.dataset.mtListo = '1';
    var modelos = Array.prototype.map.call(sec.querySelectorAll('[data-mt-modelo]'), datos).filter(Boolean);
    if (!modelos.length) return;
    var pestanas = sec.querySelectorAll('.mt-pestana');
    var q = function (s) { return sec.querySelector(s); };
    var img = q('[data-mt-img]'), muestras = q('[data-mt-muestras]'), orbita = q('[data-mt-orbita]'), orbNombre = q('[data-mt-orbita-nombre] span'), comprar = q('[data-mt-comprar]'), ver = q('[data-mt-ver]');
    var actual = 0, varActual = 0, intervalo = (parseInt(sec.getAttribute('data-intervalo'), 10) || 0) * 1000, timer = null;
    sec.style.setProperty('--mt-int', (intervalo / 1000 || 7) + 's');

    function cambiarImagen(src) {
      if (!img || !src || img.getAttribute('src') === src) return;
      var pre = new Image();
      pre.onload = function () {
        img.classList.add('mt-saliendo');
        setTimeout(function () {
          img.src = src;
          img.classList.remove('mt-saliendo');
          img.classList.add('mt-entrando');
          requestAnimationFrame(function () { requestAnimationFrame(function () { img.classList.remove('mt-entrando'); }); });
        }, reducido ? 0 : 380);
      };
      pre.src = src;
    }
    function pintarMuestras(m) {
      [muestras, orbita].forEach(function (cont) {
        if (!cont) return;
        cont.innerHTML = '';
        m.variantes.forEach(function (v, i) { cont.appendChild(crearDial(v, i, i === varActual, 'gra')); });
      });
      if (orbita) { orbita.classList.remove('mt-entra'); orbita.offsetWidth; orbita.classList.add('mt-entra'); colocarOrbita(orbita, q('[data-mt-escenario]')); }
    }
    function elegirVariante(i) {
      var m = modelos[actual], v = m.variantes[i];
      if (!v) return;
      varActual = i;
      marcar(muestras, i); marcar(orbita, i);
      q('[data-mt-variante]').textContent = 'Color: ' + v.nombre;
      if (orbNombre) { orbNombre.parentNode.classList.remove('mt-cambia'); orbNombre.parentNode.offsetWidth; orbNombre.textContent = v.nombre; orbNombre.parentNode.classList.add('mt-cambia'); }
      q('[data-mt-precio]').textContent = v.precio;
      comprar.setAttribute('data-id', v.id);
      comprar.disabled = !v.disp;
      ver.href = m.url + '?variant=' + v.id;
      cambiarImagen(v.img);
    }
    function irA(i, manual) {
      if (i === actual && sec.dataset.mtIni) return;
      sec.dataset.mtIni = '1';
      actual = (i + modelos.length) % modelos.length; varActual = 0;
      var m = modelos[actual];
      pestanas.forEach(function (p, k) {
        p.classList.toggle('mt-activo', k === actual);
        var bar = p.querySelector('.mt-pestana__barra i'); if (bar) { bar.style.animation = 'none'; bar.offsetWidth; bar.style.animation = ''; }
      });
      sec.classList.add('mt-cambiando');
      var fan = q('[data-mt-fantasma]'); fan.classList.add('mt-cambiando');
      setTimeout(function () {
        q('[data-mt-nombre]').textContent = m.nombre;
        q('[data-mt-lema]').textContent = m.lema;
        q('[data-mt-num]').textContent = ('0' + (actual + 1)).slice(-2);
        fan.textContent = m.nombre;
        pintarMuestras(m);
        elegirVariante(0);
        sec.classList.remove('mt-cambiando'); fan.classList.remove('mt-cambiando');
      }, reducido ? 0 : 420);
      if (manual) reiniciar();
    }
    function reiniciar() {
      clearInterval(timer);
      if (intervalo && !reducido) timer = setInterval(function () { if (!sec.classList.contains('mt-pausa')) irA(actual + 1); }, intervalo);
    }
    pestanas.forEach(function (p, k) { p.addEventListener('click', function () { irA(k, true); }); });
    [muestras, orbita].forEach(function (cont) {
      if (cont) cont.addEventListener('click', function (e) { var b = e.target.closest('.mt-dial'); if (b) { elegirVariante(+b.dataset.i); reiniciar(); } });
    });
    window.addEventListener('resize', function () { colocarOrbita(orbita, q('[data-mt-escenario]')); });
    /* vista previa al pasar por encima de una esfera */
    if (orbita && window.matchMedia('(hover: hover)').matches) {
      orbita.addEventListener('mouseover', function (e) {
        var b = e.target.closest('.mt-dial'); if (!b) return;
        var v = modelos[actual].variantes[+b.dataset.i]; if (v) cambiarImagen(v.img);
        if (orbNombre) orbNombre.textContent = v.nombre;
      });
      orbita.addEventListener('mouseleave', function () {
        var v = modelos[actual].variantes[varActual]; if (v) { cambiarImagen(v.img); if (orbNombre) orbNombre.textContent = v.nombre; }
      });
    }
    sec.addEventListener('mouseenter', function () { sec.classList.add('mt-pausa'); });
    sec.addEventListener('mouseleave', function () { sec.classList.remove('mt-pausa'); });
    sec.dataset.mtIni = '1';
    pintarMuestras(modelos[0]);
    elegirVariante(0);
    reiniciar();

    /* inclinación 3D con el ratón */
    var tilt = q('[data-mt-tilt]'), esc = q('[data-mt-escenario]');
    if (tilt && esc && !reducido && window.matchMedia('(hover: hover)').matches) {
      esc.addEventListener('mousemove', function (e) {
        var r = esc.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        tilt.style.transform = 'perspective(1000px) rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 14) + 'deg) scale(1.03)';
      });
      esc.addEventListener('mouseleave', function () { tilt.style.transform = ''; });
    }
  }

  /* ---------- Tarjetas de modelos ---------- */
  function initTarjeta(t) {
    if (t.dataset.mtListo) return;
    t.dataset.mtListo = '1';
    var m = datos(t.querySelector('[data-mt-modelo]'));
    if (!m) return;
    var img = t.querySelector('[data-mt-img]'), btn = t.querySelector('[data-mt-comprar]'), precio = t.querySelector('[data-mt-precio]'), enlaces = t.querySelectorAll('a[href]');
    t.querySelector('[data-mt-muestras]').addEventListener('click', function (e) {
      var b = e.target.closest('.mt-dial'); if (!b) return;
      var v = m.variantes[+b.dataset.i]; if (!v) return;
      marcar(t.querySelector('[data-mt-muestras]'), +b.dataset.i);
      btn.setAttribute('data-id', v.id); btn.disabled = !v.disp; precio.textContent = v.precio;
      enlaces.forEach(function (a) { a.href = m.url + '?variant=' + v.id; });
      if (img && v.img) { img.classList.add('mt-cambio'); setTimeout(function () { img.src = v.img; img.classList.remove('mt-cambio'); }, 250); }
    });
  }

  /* ---------- Día / noche ---------- */
  function initDiaNoche(sec) {
    if (sec.dataset.mtListo) return;
    sec.dataset.mtListo = '1';
    var b = sec.querySelector('[data-mt-interruptor]');
    b.addEventListener('click', function () {
      var on = !sec.classList.contains('mt-noche');
      sec.classList.toggle('mt-noche', on);
      b.setAttribute('aria-pressed', on);
    });
  }

  /* ---------- Fondo con profundidad ---------- */
  var fondos = [];
  function initParallaxFondo(sec) {
    if (sec.dataset.mtListo || reducido) return;
    sec.dataset.mtListo = '1';
    var f = sec.querySelector('.mt-escena__fondo'), k = parseFloat(sec.getAttribute('data-mt-parallax-fondo')) || 0;
    if (f && k) fondos.push({ sec: sec, f: f, k: k });
  }
  function moverFondos() {
    var vh = window.innerHeight;
    fondos.forEach(function (o) {
      var r = o.sec.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      o.f.style.transform = 'translate3d(0,' + (p * o.k * -3) + '%,0)';
    });
  }
  window.addEventListener('scroll', function () { requestAnimationFrame(moverFondos); }, { passive: true });

  /* ---------- Galería arrastrable ---------- */
  function initArrastre(pista) {
    if (pista.dataset.mtListo) return;
    pista.dataset.mtListo = '1';
    var abajo = false, x0 = 0, s0 = 0, movido = false;
    pista.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; abajo = true; movido = false; x0 = e.clientX; s0 = pista.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!abajo) return; var dx = e.clientX - x0; if (Math.abs(dx) > 4) { movido = true; pista.classList.add('mt-arrastrando'); } pista.scrollLeft = s0 - dx; });
    window.addEventListener('pointerup', function () { abajo = false; setTimeout(function () { pista.classList.remove('mt-arrastrando'); }, 0); });
    pista.addEventListener('click', function (e) { if (movido) { e.preventDefault(); movido = false; } }, true);
    var sec = pista.closest('.mt-section');
    sec.querySelectorAll('[data-mt-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        var item = pista.querySelector('.mt-galeria-h__item');
        pista.scrollBy({ left: (+b.getAttribute('data-mt-dir')) * (item ? item.offsetWidth + 20 : 400), behavior: 'smooth' });
      });
    });
  }

  /* ---------- Producto: zoom y barra fija ---------- */
  function initProductoV2(raiz) {
    if (raiz.dataset.mtV2) return;
    raiz.dataset.mtV2 = '1';
    var p = raiz.querySelector('.mt-galeria__principal');
    if (p && window.matchMedia('(hover: hover)').matches) {
      p.addEventListener('mousemove', function (e) {
        var r = p.getBoundingClientRect();
        p.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        p.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      p.addEventListener('mouseenter', function () { p.classList.add('mt-zoom'); });
      p.addEventListener('mouseleave', function () { p.classList.remove('mt-zoom'); });
    }
    var barra = document.querySelector('[data-mt-barra]'), boton = raiz.querySelector('[data-mt-boton]');
    if (barra && boton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        barra.classList.toggle('mt-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(boton);
      barra.querySelector('[data-mt-barra-btn]').addEventListener('click', function () { boton.click(); });
      var precio = raiz.querySelector('[data-mt-precio]'), bp = barra.querySelector('[data-mt-barra-precio]');
      if (precio && bp && 'MutationObserver' in window) new MutationObserver(function () { bp.textContent = precio.textContent; }).observe(precio, { childList: true, characterData: true, subtree: true });
    }
    /* nombre de la esfera elegida junto a la etiqueta */
    raiz.querySelectorAll('.mt-opcion').forEach(function (fs) {
      var lbl = fs.querySelector('[data-mt-actual]');
      fs.addEventListener('change', function (e) { if (lbl && e.target.value) lbl.textContent = e.target.value; });
    });
    /* complemento opcional (estuche): se añade en la misma compra que el reloj */
    var extra = raiz.querySelector('[data-mt-extra]');
    var modal = raiz.querySelector('[data-mt-extra-modal]');
    if (extra && modal) {
      var abrir = function (e) { e.preventDefault(); e.stopPropagation(); if (modal.showModal) modal.showModal(); else modal.setAttribute('open', ''); };
      raiz.querySelectorAll('[data-mt-extra-ver]').forEach(function (b) {
        b.addEventListener('click', abrir);
        b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') abrir(e); });
      });
      var cerrar = function () { if (modal.close) modal.close(); else modal.removeAttribute('open'); };
      modal.querySelector('[data-mt-extra-cerrar]').addEventListener('click', cerrar);
      modal.addEventListener('click', function (e) { if (e.target === modal) cerrar(); });
      modal.querySelector('[data-mt-extra-anadir]').addEventListener('click', function () { extra.checked = true; extra.dispatchEvent(new Event('change', { bubbles: true })); cerrar(); });
      var principal = modal.querySelector('[data-mt-extra-foto]');
      modal.querySelectorAll('[data-mt-extra-mini]').forEach(function (m) {
        m.addEventListener('click', function () {
          principal.src = m.getAttribute('data-mt-extra-mini'); principal.removeAttribute('srcset');
          modal.querySelectorAll('[data-mt-extra-mini]').forEach(function (x) { x.classList.toggle('mt-activo', x === m); });
        });
      });
    }
    function itemsCompra(id, qty) {
      var n = qty ? Number(qty.value) || 1 : 1, items = [{ id: Number(id), quantity: n }];
      if (extra && extra.checked) items.push({ id: Number(extra.value), quantity: n });
      return items;
    }
    /* Añadir al carrito con el cajón del carrito */
    var form = raiz.querySelector('form[action*="/cart/add"]');
    if (form && document.querySelector('cart-drawer')) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = form.querySelector('[name="id"]').value, qty = form.querySelector('[name="quantity"]');
        var drawer = document.querySelector('cart-drawer');
        boton.classList.add('mt-cargando');
        fetch(raizCarrito + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itemsCompra(id, qty), sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            boton.classList.remove('mt-cargando');
            if (!res.ok) { toast(null, res.j.description || 'No se ha podido añadir'); return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.j);
          })
          .catch(function () { form.submit(); });
      });
    }
  }

  /* ---------- Buscador de preguntas frecuentes ---------- */
  function initAyuda(sec) {
    if (sec.dataset.mtListo) return;
    sec.dataset.mtListo = '1';
    var input = sec.querySelector('[data-mt-ayuda-input]'), vacio = sec.querySelector('[data-mt-ayuda-vacio]');
    if (!input) return;
    var norm = function (t) { return t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); };
    input.addEventListener('input', function () {
      var q = norm(input.value.trim()), total = 0;
      document.querySelectorAll('[data-mt-faq]').forEach(function (f) {
        var vis = 0;
        f.querySelectorAll('.mt-faq__item').forEach(function (it) {
          var ok = !q || norm(it.textContent).indexOf(q) > -1;
          it.hidden = !ok;
          if (ok) { vis++; if (q) it.open = true; }
        });
        if (!q) f.querySelectorAll('.mt-faq__item').forEach(function (it, k) { it.open = false; });
        f.classList.toggle('mt-oculta', vis === 0);
        total += vis;
      });
      if (vacio) vacio.hidden = total > 0;
    });
  }

  function iniciar() {
    document.querySelectorAll('[data-mt-ayuda]').forEach(initAyuda);
    document.querySelectorAll('[data-mt-vitrina]').forEach(initVitrina);
    document.querySelectorAll('[data-mt-tarjeta]').forEach(initTarjeta);
    document.querySelectorAll('[data-mt-dianoche]').forEach(initDiaNoche);
    document.querySelectorAll('[data-mt-parallax-fondo]').forEach(initParallaxFondo);
    document.querySelectorAll('[data-mt-arrastre]').forEach(initArrastre);
    document.querySelectorAll('[data-mt-producto]').forEach(initProductoV2);
    moverFondos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
